import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { UserList } from '@/pages/super-admin/user-list';

const usersSearchSchema = z.object({
	page: z.coerce.number().default(1),
	limit: z.coerce.number().default(10),
	search: z.string().optional(),
	sortBy: z.enum(['firstName', 'lastName', 'createdAt', 'lastActiveAt']).default('createdAt'),
	sortOrder: z.enum(['asc', 'desc']).default('asc'),
	plan: z.enum(['FREE', 'TRIAL', 'START', 'STANDARD', 'PREMIUM']).optional(),
});

export const Route = createFileRoute('/_authenticated/super-admin/users/')({
	component: UserList,
	validateSearch: usersSearchSchema,
});
